import * as React from "react"
import type { SVGProps } from "react"
const SvgTagPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.43a2 2 0 0 1-1.43-.6l-7.15-7.15q-.3-.3-.43-.66a2 2 0 0 1 0-1.5q.13-.37.43-.67l7.8-7.82q.28-.28.66-.44a2 2 0 0 1 .77-.16h7.18q.83 0 1.4.59.6.59.6 1.4v7.18q0 .3-.09.57a6 6 0 0 0-1.91-.66V5.43h-7.15L4 13.28l7.15 7.15.94-.95q.2 1.12.78 2.06l-.3.29a2 2 0 0 1-1.42.6" />
    <path d="M15.48 10.43q.61 0 1.06-.44.44-.45.44-1.06 0-.63-.44-1.06a1.5 1.5 0 0 0-1.06-.44q-.62 0-1.07.44a1.5 1.5 0 0 0-.43 1.06q0 .63.43 1.06.45.45 1.07.44m-.48 9h2v2q0 .42.29.71.29.3.71.29c.42-.01.52-.1.71-.29a1 1 0 0 0 .29-.71v-2h2q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29h-2v-2a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29 1 1 0 0 0-.71.29 1 1 0 0 0-.29.71v2h-2a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgTagPlus
